import { OFFLINE_QUEUE_APP } from "~/helpers/offline/queueMeta";
import computeAvailabilityPendingCount from "~/hooks/computeAvailabilityPendingCount";
import { useAppSelector } from "~/hooks/reduxHooks";
import { selectFailedCountForApp, selectQueuedCountForApp } from "~/store/offlineQueueSlice";

export interface UseAvailabilityPendingCountReturn {
	count: number;
}

const useAvailabilityPendingCount = (): UseAvailabilityPendingCountReturn => {
	const queuedCount = useAppSelector(selectQueuedCountForApp(OFFLINE_QUEUE_APP.AVAILABILITY));
	const failedCount = useAppSelector(selectFailedCountForApp(OFFLINE_QUEUE_APP.AVAILABILITY));
	const unpostedCounts = useAppSelector((state) => state.availability.unpostedCounts);
	return { count: computeAvailabilityPendingCount(queuedCount, failedCount, unpostedCounts) };
};

export default useAvailabilityPendingCount;
